import {Alert, Box, CircularProgress, Typography} from '@mui/material';
import {useEffect, useState} from 'react';
import {iapApi} from '../../api/iapApi';
import {IapProductList} from './IapProductList';
import type {IapProduct} from '../../types/iap';

export function IapProductsPage() {
    const [products, setProducts] = useState<IapProduct[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const load = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await iapApi.getAll();
            setProducts(data ?? []);
        } catch (e: unknown) {
            const msg = e instanceof Error ? e.message : '오류 발생';
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        void load();
    }, []);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress/>
            </Box>
        );
    }

    if (error) {
        return <Alert severity="error">{error}</Alert>;
    }

    return (
        <Box sx={{p: 3}}>
            <Typography variant="h4" sx={{mb: 3}}>IAP 상품 관리</Typography>
            <IapProductList products={products} onRefresh={load}/>
        </Box>
    );
}
